import { render } from "./articleLeft.vue?vue&type=template&id=9b311836&scoped=true"
import script from "./articleLeft.vue?vue&type=script&lang=js"
export * from "./articleLeft.vue?vue&type=script&lang=js"

import "./articleLeft.vue?vue&type=style&index=0&id=9b311836&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b311836"]])

export default __exports__